// extracted by mini-css-extract-plugin
module.exports = {"container":"ItemFlag_container__58rDx","icon":"ItemFlag_icon__ReOwI"};